import { Injectable } from '@angular/core';

@Injectable()
export class HelpersService {
    constructor() {}

    /**
     * Returns a image preview when is loaded using a
     * input file
     * @param files file loaded
     */
    getImagePreview(files: any) {
        let response = {
            preview: null,
            imagePath: null,
            error: false,
        };

        return new Promise((resolve) => {
            if (files.length === 0) {
                resolve(response);
            }

            const mimeType = files[0].type;
            if (mimeType.match(/image\/*/) == null) {
                response.error = true;
                resolve(response);
            }

            const reader = new FileReader();
            response.imagePath = files;
            reader.readAsDataURL(files[0]);
            reader.onload = (_event) => {
                response.preview = reader.result;
                resolve(response);
            };
        });
    }

    validUrl(str: string) {
        var pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',

            'i'
        ); // fragment locator

        return !!pattern.test(str);
    }

    /**
     * Return the slug of a string
     * Example: mis cosas nuevas -> mis-cosas-nuevas
     * @param string
     */
    slugify(string: string) {
        return string
            .toLowerCase()
            .replace('-', '')
            .replace(/[^\u00BF-\u1FFF\u2C00-\uD7FF\w0-9]/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    createImageFromBlob(image: Blob): Promise<string | ArrayBuffer> {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.addEventListener(
                'load',
                () => {
                    resolve(reader.result);
                },
                false
            );

            if (image) {
                reader.readAsDataURL(image);
            }
        });
    }
}

export * from './flexiform.helper';
export * from './date.helper';
